import { render, staticRenderFns } from "./dom.vue?vue&type=template&id=58c9260c&scoped=true"
import script from "./dom.vue?vue&type=script&lang=ts"
export * from "./dom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c9260c",
  null
  
)

export default component.exports